module.exports = __webpack_public_path__ + "img/upload.1f0893bd.svg";